<p-toast position="bottom-right"></p-toast>

<p-dialog
    [(visible)]="displayNuevoCampoDialog"
    [style]="{ width: '500px' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="onNuevoCampoDialogClosed()"
    [header]="campoParaEditar ? 'Editar Campo' : 'Agregar Nuevo Campo'"
>
    <app-nuevo-campo-modal 
        [sClave]="form.get('clave')?.value || ''"
        [campoParaEditar]="campoParaEditar"
        (onSave)="onNuevoCampoSaved($event)">
    </app-nuevo-campo-modal>
</p-dialog>

<form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P269F0001">
    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="clave" class="form-control" 
                [placeholder]="'Ingrese el código (máx. 4 caracteres)'" 
                [disabled]="isEditMode"
                maxlength="4" appPermissionControl="P269K0001">
            <label>Código (máx. 4 caracteres)</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="descripcion" class="form-control" 
                [placeholder]="'Ingrese la descripción'"
                [disabled]="isEditMode" appPermissionControl="P269K0002">
            <label>Descripción</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <p-dropdown 
                formControlName="tipo" 
                [options]="opcionesTipo" 
                optionLabel="sValor" 
                appendTo="body"
                optionValue="sOpcion"
                [filter]="true"
                placeholder="Seleccione el tipo"
                class="w-100"
                [disabled]="isEditMode" appPermissionControl="P269K0003">
            </p-dropdown>
            <label>Tipo</label>
        </div>
    </div>

    <div class="button-section">
        <button *ngIf="!isEditMode" mat-flat-button class="btn-success btn-menu" (click)="onSubmit()"
            [disabled]="!form.valid || loading">
            <mat-icon>save</mat-icon>
            Guardar
        </button>
        <button *ngIf="isEditMode" mat-flat-button class="btn-search btn-menu" (click)="openCustomizables()" appPermissionControl="P269B0002">
            <mat-icon>settings</mat-icon>
            Customizables
        </button>
        <button *ngIf="isEditMode" mat-flat-button class="btn-new btn-menu" (click)="openNuevo()" appPermissionControl="P269B0003">
            <mat-icon>add</mat-icon>
            Nuevo
        </button>
    </div>
</form>

<!-- Tabla de campos customizables (solo visible en modo edición) -->
<div *ngIf="isEditMode" class="table-section mt-4">    
    <p-table
        [value]="camposCustomizables" 
        [paginator]="true" 
        [rows]="5"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[5, 10, 20]"
        [scrollable]="true"
        [scrollHeight]="'200px'"
        styleClass="p-datatable-gridlines"
        [resizableColumns]="true"
        [autoLayout]="true"
        responsiveLayout="scroll"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} campos"
     appPermissionControl="P269T0001">
        <ng-template pTemplate="header">
            <tr>
                <th class="th-prime" appPermissionControl="P269C0001">Orden</th>
                <th class="th-prime" appPermissionControl="P269C0002">Campo</th>
                <th class="th-prime" appPermissionControl="P269C0003">Label</th>
                <th class="th-prime" style="width: 100px;" appPermissionControl="P269C0004">Acción</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-campo>
            <tr>
                <td class="td-prime">{{ campo.orden }}</td>
                <td class="td-prime">{{ campo.campo }}</td>
                <td class="td-prime">{{ campo.label }}</td>
                <td class="td-prime">
                    <div class="d-flex gap-2 justify-content-center">
                        <button
                            pButton
                            icon="pi pi-eye"
                            class="p-button-rounded p-button-info p-button-text"
                            (click)="editarCampo(campo)"
                            pTooltip="Editar"
                         appPermissionControl="P269B0001"></button>
                        <button
                            pButton
                            icon="pi pi-trash"
                            class="p-button-rounded p-button-danger p-button-text"
                            (click)="eliminarCampo(campo)"
                            pTooltip="Eliminar"
                         appPermissionControl="P269B0004"></button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" class="text-center td-prime">
                    <span>No hay campos customizables</span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div> 